<template>
  <tr class="document-map-to-type">
    <td>
      <a :href="showLink" target="_blank" v-on:click.stop v-if="canShow">
        {{ this.name }}
      </a>
      <span v-else>
        {{ this.name }}
      </span>
    </td>
    <td class="compact">
      <HumanFilesizeComponent :bytes="this.size"></HumanFilesizeComponent>
    </td>
    <td class="compact">
      <a-select
              v-if="editable"
              :default-value="document.document_type_id ? document.document_type_id : undefined"
              show-search
              :placeholder="document.extension == ('pdf' || 'tiff' || 'tif') ? 'Selecteer een document type' : 'Dit bestandstype wordt niet ondersteund'"
              option-filter-prop="children"
              style="width: 550px"
              :filter-option="filterOption"
              @change="handleChange"
              :disabled="document.extension != ('pdf' || 'tiff' || 'tif')"
      >
        <a-select-option key="none" :value="0">
          Geen
        </a-select-option>
        <a-select-option v-for="documentType in documentTypes" :key="documentType.id" :value="documentType.id">
          {{ documentType.name }}
        </a-select-option>
      </a-select>
      <span v-else>
        {{ document.document_type.data.name }}
      </span>
    </td>
  </tr>
</template>

<script>
import HumanFilesizeComponent from '~/components/HumanFilesizeComponent';

const moment = require('moment');

export default {
  name: "DocumentMapToTypeComponent",
  props: {
    document: {
      type: Object,
      required: true
    },
    documentTypes: {
      type: Array,
      required: false,
      default: () => []
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    HumanFilesizeComponent
  },
  data() {
    return {
      editing: false,
    }
  },
  computed: {
    name() {
      return this.document.name;
    },
    canShow() {
      return typeof this.document.show_link !== "undefined";
    },
    showLink() {
      return this.document.show_link;
    },
    size() {
      return this.document.filesize;
    },
  },
  created() {
  },
  methods: {
    handleChange(value) {
      let documentType = this.documentTypes.find(documentType => documentType.id === value);

      this.$emit('change', this.document, documentType)
    },
    filterOption(input, option) {
      return (
              option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
}
</script>

<style scoped>

</style>
